import { offlineInit } from '@eppo/js-client-sdk'
import {
  BanditParameters,
  BanditVariation,
  MemoryOnlyConfigurationStore,
} from '@eppo/js-client-sdk-common'
import { logger } from '@moonpig/web-core-monitoring'
import {
  EppoBanditModels,
  EppoBanditVariations,
  EppoConfiguration,
} from '../../types'
import { logAssignment } from '../trackExperiment/trackExperiment'
import { filterBotFriendlyAllocations } from '../../utils/filter-bot-friendly-allocations/filter-bot-friendly-allocations'

type CreateEppoClient = {
  flagsConfiguration: EppoConfiguration | null
  banditVariations?: EppoBanditVariations | null
  banditModels?: EppoBanditModels | null
  isBot?: boolean
}

let cachedEppoConfiguration: EppoConfiguration | null = null
let cachedBanditVariations: EppoBanditVariations | null = null
let cachedBanditModels: EppoBanditModels | null = null

export const createEppoClient = ({
  flagsConfiguration,
  banditVariations,
  banditModels,
  isBot = false,
}: CreateEppoClient) => {
  if (flagsConfiguration) {
    cachedEppoConfiguration = flagsConfiguration
  }
  if (banditVariations !== undefined) {
    cachedBanditVariations = banditVariations
  }
  if (banditModels !== undefined) {
    cachedBanditModels = banditModels
  }

  if (!cachedEppoConfiguration) return null

  let configuration = cachedEppoConfiguration

  if (isBot) {
    configuration = filterBotFriendlyAllocations(configuration)
  }

  const client = offlineInit({
    flagsConfiguration: configuration,
    isObfuscated: false,
    assignmentLogger: { logAssignment },
    banditLogger: {
      logBanditAction: banditEvent => {
        logger.info(`Bandit action: ${JSON.stringify(banditEvent)}`)
      },
    },
  })

  const banditVariationsToUse = cachedBanditVariations ?? null
  const banditModelsToUse = cachedBanditModels ?? null

  if (banditVariationsToUse !== null || banditModelsToUse !== null) {
    const banditVariationStore = new MemoryOnlyConfigurationStore<
      BanditVariation[]
    >()
    banditVariationStore.setEntries(banditVariationsToUse ?? {})
    client.setBanditVariationConfigurationStore(banditVariationStore)

    const banditModelStore =
      new MemoryOnlyConfigurationStore<BanditParameters>()
    banditModelStore.setEntries(banditModelsToUse ?? {})
    client.setBanditModelConfigurationStore(banditModelStore)
  }

  return client
}
